// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1WLi7","row":"Node_row__2fow-","label":"Node_label__2TJku","footer":"Node_footer__3Y6zQ"};